import { Card, Row, Col, Badge } from 'react-bootstrap';
import { formatCurrency } from '../../../../utils/formatters'
import { getReferralSourceLabel } from '../../../../constants/constants';

const ReadOnlyCaresProgramOptions = ({
  tpaFlg,
  tpaMonths,
  tpaMonthlyInstallmentEst,
  weatherizationProgramInterest,
  referralSource
}) => {

  return (
    <>
      <Card className="bg-secondary-soft">
        <Card.Header>Program Options</Card.Header>
        <Card.Body>
          <Row>
            <Col xs={11}>
              <span>Is Customer Requesting a Long-Term Payment Arrangement on their past due balance?</span>
            </Col>
            <Col>
              <Badge bg={tpaFlg? 'success': 'secondary'} >{tpaFlg? 'Yes': 'No'}</Badge>
            </Col>
          </Row>

          {tpaFlg && (
            <>
              <Row>
                <Col>
                  <span>Number of Months</span>
                </Col>
                <Col>
                  <Badge bg="success">{tpaMonths}</Badge>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>Monthly Installment Estimate</span>
                </Col>
                <Col>
                  <Badge bg="success">{formatCurrency(tpaMonthlyInstallmentEst)}</Badge>
                </Col>
              </Row>
            </>
          )}
          <hr />
          <Row>
            <Col xs={11}>
              <span>Is the customer interested in hearing about our <i>free</i> weatherization program?</span>
            </Col>
            <Col>
              <Badge bg={weatherizationProgramInterest? 'success': 'secondary'} >{weatherizationProgramInterest? 'Yes': 'No'}</Badge>
            </Col>
          </Row>
          {referralSource && (
            <>
              <hr />
              <Row>
                <Col>
                  <div className="text-center mb-2">Referral Source:</div>
                  <Card className="p-2 text-center">{getReferralSourceLabel(referralSource)}</Card>
                </Col>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default ReadOnlyCaresProgramOptions;